module.exports = __webpack_public_path__ + "static/media/inventoryAptBook.e6d3abf7.svg";